// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Icon from './components/partials/Icon'
import store from './store.js'
import router from './router'
import VueCookie from 'vue-cookie'
import VuejsClipper from 'vuejs-clipper'
import moment from 'moment'
import * as VueGoogleMaps from 'vue2-google-maps'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import vClickOutside from 'v-click-outside'
import Toasted from 'vue-toasted'
import VueRx from 'vue-rx'

// CSS
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/lint/lint.css'
import 'normalize.css'
import './assets/sass/style.scss'

// Vue Rx
Vue.use(VueRx)

// Image cropper
Vue.use(VuejsClipper)

// Cookies
Vue.use(VueCookie)

// Click outside
Vue.use(vClickOutside)

// Custom SVG icons
Vue.component('icon', Icon)

// Gmaps
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCufPAdzWxMJgkyXJ14uk-LJK2G-xLUMBI',
    libraries: 'places',
    language: 'en',
  },
})

// Vue moment
Vue.prototype.moment = moment

// Sentry.io
if (process.env.NODE_ENV === 'production') {
  Raven.config('https://abb6cc20273049b9810d0312d64f3eee@sentry.io/1282455').addPlugin(RavenVue, Vue).install()
}

// Toast notifications
Vue.use(Toasted, { position: 'bottom-right' })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: '<App/>',
  render: (h) => h(App),
}).$mount('#app')
